<template>
	<v-dialog v-model="dialog" persistent max-width="500">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">依頼の編集</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="py-2">
				<p v-if="requirement.user_id != user.id" class="red--text">他の人が作成した依頼です</p>
				<p v-if="requirement.status_id != 'draft'" class="red--text">
					この依頼は既に発行済みです。<br />必要に応じて更新前に関係者と調整を行い、更新後に関係者に別途連絡を入れてください。<br />更新後に履歴が作成されます。
				</p>
				<v-divider class="my-2" v-if="requirement.status_id != 'draft'" />
				<div v-if="requirement && dataKey == 'matter_id'" class="d-flex">
					<p>現在の値：</p>
					<p
						class="pre-wrap"
						v-text="requirement.matter ? common.returnMatterInfo(requirement.matter) : ''"
					></p>
				</div>
				<div v-else-if="requirement && dataKey == 'matter_product_id'" class="d-flex">
					<p>現在の値：（見積製品）</p>
					<p class="pre-wrap" v-text="common.matterProductByRequirement(requirement)"></p>
				</div>
				<div v-else-if="requirement && dataKey == 'ordered_product_id'" class="d-flex">
					<p>現在の値：（製番）</p>
					<p class="pre-wrap" v-text="common.orderedProductByRequirement(requirement)" />
				</div>
				<div v-else-if="requirement && dataKey == 'order_individual_info_id'" class="d-flex">
					<p>現在の値：（枝番）</p>
					<p class="pre-wrap" v-text="common.orderIndividualInfoByRequirement(requirement)" />
				</div>

				<p v-else-if="requirement">現在の値：{{ requirement[dataKey] }}</p>
			</v-card-text>
			<v-form v-model="valid">
				<v-card-actions>
					<v-text-field
						label="希望納期"
						dense
						outlined
						:rules="[rules.required]"
						class="mt-4"
						hint="依頼の希望納期を記入してください"
						v-model="newRequirement[dataKey]"
						v-if="dataType == 'string'"
					/>

					<v-textarea
						class="mt-4"
						:label="label"
						:rules="[]"
						outlined
						dense
						v-model="newRequirement[dataKey]"
						v-if="dataType == 'text'"
					/>

					<v-text-field
						:label="label"
						type="date"
						dense
						outlined
						:rules="[rules.required]"
						class="mt-4"
						v-model="newRequirement[dataKey]"
						v-if="dataType == 'date'"
					/>
					<div class="w100" v-if="dataType == 'matter'">
						<v-row no-gutters v-if="!selectedMatter" class="flex-nowrap">
							<v-text-field
								label="案件を検索"
								dense
								outlined
								:rules="[]"
								class="mt-4"
								hint="絞り込みしたい案件の見積番号・受注番号・製番を入力してください。"
								v-model="searchWord"
							/>
							<v-btn
								class="ma-2 pa-2 mt-4"
								:disabled="!searchWord"
								color="primary"
								@click="searchMatters()"
								>検索</v-btn
							>
						</v-row>
						<v-row v-if="searchedMatters" align="center" justify="space-around">
							<p class="secondary--text" v-if="noMatterFlag">該当する案件データはありません</p>
							<v-btn
								height="auto"
								class="ma-2 pa-2"
								depressed
								v-for="matter in searchedMatters"
								:key="matter.id"
								@click="setMatter(matter)"
							>
								<div class="text-left">
									<p
										v-if="matter.name"
										class="pre-wrap"
										v-text="common.returnMatterInfoWithOrderNumber(matter)"
									></p>
								</div>
							</v-btn>
						</v-row>
						<v-card class="mx-auto my-2" v-if="selectedMatter">
							<v-card-text>
								<v-flex class="justify-space-between">
									<div>
										<p v-if="selectedMatter">案件名：{{ selectedMatter.name }}</p>
										<p>
											見積番号：{{ selectedMatter.quotation_number }}-{{
												selectedMatter.quotation_sub_number
											}}
										</p>
										<p>得意先：{{ selectedMatter.regular_customer_company.name }}</p>
										<p>向け先：{{ selectedMatter.customer_company.name }}</p>
									</div>
									<v-icon @click="removeMatter">mdi-close</v-icon>
								</v-flex>
							</v-card-text>
						</v-card>
					</div>
					<div class="w100" v-if="dataType == 'matter_product'">
						<v-select
							label="見積製品絞り込み"
							:items="targetList"
							item-text="name"
							item-value="id"
							hint="対象の製品を選択してください"
							no-data-text="対象なし/読み込み中"
							class="mt-4"
							outlined
							dense
							v-model="newRequirement[dataKey]"
						/>
					</div>
					<div class="w100" v-if="dataType == 'ordered_product'">
						<v-select
							label="受注製品絞り込み"
							:items="targetList"
							item-text="name"
							item-value="id"
							hint="対象の製番を選択してください"
							no-data-text="対象なし/読み込み中"
							class="mt-4"
							outlined
							dense
							v-model="newRequirement[dataKey]"
						/>
					</div>
					<div class="w100" v-if="dataType == 'order_individual_info'">
						<v-select
							label="枝番で絞り込み"
							:items="targetList"
							item-text="name"
							item-value="id"
							hint="対象の枝番を選択してください"
							no-data-text="対象なし/読み込み中"
							class="mt-4"
							outlined
							dense
							v-model="newRequirement[dataKey]"
						/>
					</div>
				</v-card-actions>
				<v-card-actions>
					<v-textarea
						class="mt-4"
						label="変更理由"
						:rules="[rules.required]"
						outlined
						dense
						v-model="reason"
						v-if="requirement.status_id != 'draft'"
					/>
				</v-card-actions>
				<v-card-actions>
					<v-row no-gutters>
						<v-col cols="4" />
						<v-col cols="4">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="updateRequirement" :disabled="!valid">
									<v-icon class="mr-2">mdi-arrow-up-bold-box-outline</v-icon>
									更新する
								</v-btn>
							</v-row>
						</v-col>

						<v-col cols="4">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
export default {
	data() {
		return {
			common: common,
			dialog: false,
			rules: rules,
			valid: false,
			noMatterFlag: false,
			requirement: { status_id: "", user_id: "", id: "" },
			selectedMatter: null,
			label: "",
			dataType: "",
			dataKey: "",
			searchWord: "",
			searchedMatters: [],
			targetList: [],
			newRequirement: Object,
			showIndex: Number,
			user: { id: "" },
			reason: "",
		}
	},
	methods: {
		setEditData(dataSet) {
			// 親から呼ぶメソッド
			this.requirement = dataSet.requirement
			this.selectedMatter = dataSet.matter
			this.label = dataSet.label
			this.dataType = dataSet.dataType
			this.dataKey = dataSet.dataKey
			this.showIndex = dataSet.showIndex
			this.dialog = true
			this.user = dataSet.user
			if (dataSet.dataKey == "message") {
				this.newRequirement.message = this.requirement.message
			}
		},
		setMatter(matter) {
			this.selectedMatter = matter
			this.searchedMatters = []
		},
		removeMatter() {
			this.selectedMatter = null
		},
		closeDialog() {
			this.dialog = false
		},
		searchMatters() {
			this.searchedMatters = []
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/matter_search.json", {
					headers,
					params: {
						q: { quotation_number_or_order_number_cont: this.searchWord },
						qq: { product_number_cont: this.searchWord },
					},
				})
				.then((response) => {
					this.searchedMatters = response.data.matters
					if (this.searchedMatters.length == 0) {
						this.noMatterFlag = true
					}
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		updateRequirement() {
			if (this.requirement.status_id != "draft" && this.reason == "") {
				this.$store.dispatch("setFlash", {
					text: "理由は必須です",
					type: "alert",
				})
				return
			}
			const headers = authenticate.setHeader()
			let changed_column = [this.dataKey]
			switch (this.dataKey) {
				case "matter_id":
					if (!this.newRequirement.matter_id) {
						this.$store.dispatch("setFlash", {
							text: "案件は必須です",
							type: "alert",
						})
						return
					}
					changed_column.concat([
						"matter_product_id",
						"ordered_product_id",
						"order_individual_info_id",
					])
				case "matter_product_id":
					changed_column.push("order_individual_info_id")
				case "ordered_product_id":
					changed_column.push("order_individual_info_id")
			}
			axios
				.put(
					`/erp/v1/requirements/${this.requirement.id}`,
					{
						requirement_id: this.requirement.id,
						changed_column: changed_column,
						fix: {
							reason: this.reason,
							changed_column: changed_column.toString(),
						},
						requirement: {
							[this.dataKey]: this.newRequirement[this.dataKey],
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
					this.dialog = false
					this.reason = ""
					this.$emit("update-requirement", {
						changed_column,
						data: res.data.requirement,
						fix: res.data.requirement_fix,
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		selectedMatter() {
			if (this.selectedMatter) {
				this.newRequirement["matter_id"] = this.selectedMatter.id
			} else {
				this.newRequirement["matter_id"] = ""
			}
		},
		dataType() {
			if (this.dataType == "matter_product") {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/matter_products.json", {
						headers,
						params: {
							matter_id: this.requirement.matter_id,
						},
					})
					.then((response) => {
						this.targetList = response.data.matter_products
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			} else if (this.dataType == "ordered_product") {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/matter_ordered_products.json", {
						headers,
						params: {
							matter_id: this.requirement.matter_id,
						},
					})
					.then((response) => {
						this.targetList = response.data.ordered_products
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else if (this.dataType == "order_individual_info") {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/order_individual_infos.json", {
						headers,
						params: {
							op_id: this.requirement.ordered_product_id,
						},
					})
					.then((response) => {
						this.targetList = response.data.individual_infos
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			}
		},
	},
}
</script>
<style scoped>
.w100 {
	width: 100%;
}
</style>
